// @ts-nocheck
let holidays = [],
  msPerDay = 86400000,
  productInputFormSection = document.querySelector('variant-radios'),
  productInputForm = document.querySelector(
    `#product-form-${productInputFormSection?.dataset.section}`
  ),
  shippingModal = document.querySelector('.product-shipping-modal.container'),
  elmCountriesSelect = document.getElementById('countries-list'),
  elmCountriesList = document.getElementById('shipping-countries-list'),
  elmCountryFlagWrapper = document.querySelector('.country-selector__flag');

const days_min = window.delivery.days_min,
  days_max = window.delivery.days_max,
  dateNow = window.delivery.date_now,
  dateMax = window.delivery.date_max,
  isoCode = window.delivery.iso_code,
  stores = ['SK', 'CZ', 'PL', 'HU'],
  intlShippingEnabled = window.delivery.international_shipping_enabled;

(function getInitialData() {
  if (intlShippingEnabled) {
    (async function asyncGetIntlShippingData() {
      await getIntlShippingData();
      getDeliveryRange(
        window.delivery.variables.min,
        window.delivery.variables.max
      );
    })();
  } else {
    getDeliveryRange(days_min, days_max);
  }
})();

async function getDeliveryRange(min, max) {
  if (stores.includes(isoCode)) {
    let dates = await fetchHolidaysAPI();
    dates.forEach((date) => {
      holidays.push(date.startDate);
    });
  } else {
    getHolidaysJSON();
  }

  let datesRange = getDatesRange(
    Date.now() + window.selected_variant_delivery_info?.shipping_delay * msPerDay
  );

  checkWorkingDates(
    datesRange,
    window.selected_variant_delivery_info?.shipping_delay,
    window.selected_variant_delivery_info?.shipping_delay,
    min + window.selected_variant_delivery_info?.shipping_delay,
    max + window.selected_variant_delivery_info?.shipping_delay
  );

  getVariantShippingInfo(
    window.selected_variant_delivery_info?.available,
    window.selected_variant_delivery_info?.has_preorder_status,
    window.selected_variant_delivery_info?.instock_date,
    window.selected_variant_delivery_info?.available
      ? 0
      : window.selected_variant_delivery_info?.shipping_delay,
    min,
    max
  );

  updateFreeShippingInfo(
    window.selected_variant_delivery_info?.available,
    window.selected_variant_delivery_info?.free_shipping
  );
}

async function fetchHolidaysAPI() {
  try {
    const response = await fetch(
      `https://openholidaysapi.org/PublicHolidays?countryIsoCode=${isoCode}&validFrom=${dateNow}&validTo=${dateMax}`
    );
    let dates = await response.json();

    return await dates;
  } catch (error) {
    console.log(error);
  }
}

function getHolidaysJSON() {
  let dt = luxon.DateTime.local();
  luxon.Settings.defaultLocale = 'sk-SK';
  luxon.Settings.defaultZone = 'Europe/Bratislava';

  let thisYear = new Date().getFullYear();

  const isGoodFriday = function (inst) {
    const [easterMonth, easterDay] =
      dt.availableHolidayHelpers.getEasterMonthAndDay(inst.year);
    return [thisYear, easterMonth, easterDay - 2];
  };
  const isEasterMonday = function (inst) {
    const [easterMonth, easterDay] =
      dt.availableHolidayHelpers.getEasterMonthAndDay(inst.year);
    return [thisYear, easterMonth, easterDay + 1];
  };

  const myHolidays = [
    [thisYear, 1, 1],
    [thisYear, 5, 1],
    isGoodFriday(dt),
    isEasterMonday(dt),
    [thisYear, 7, 5],
    [thisYear, 12, 24],
    [thisYear, 12, 25],
    [thisYear, 12, 26],
  ];

  (function checkHolidays() {
    const Interval = luxon.Interval;
    let dateNowArr = dateNow.split('-');
    let dateMaxArr = dateMax.split('-');
    const interval = Interval.fromDateTimes(
      DateTime.local(
        parseInt(dateNowArr[0]),
        parseInt(dateNowArr[1]),
        parseInt(dateNowArr[2])
      ),
      DateTime.local(
        parseInt(dateMaxArr[0]),
        parseInt(dateMaxArr[1]),
        parseInt(dateMaxArr[2])
      )
    );

    myHolidays.forEach((holiday) => {
      let holidayObj = luxon.DateTime.utc(holiday[0], holiday[1], holiday[2]);
      if (interval.contains(holidayObj.ts)) {
        holidays.push(convertToDateFormat(holidayObj.ts));
      }
    });
  })();
}

productInputFormSection?.addEventListener(
  'change',
  calculateVariantShippingDates
);

function calculateVariantShippingDates(e) {
  e.preventDefault();

  if (!this.currentVariant?.available) {
    shippingModal.classList.add('variant-unavailable--hide');
  } else {
    shippingModal.classList.remove('variant-unavailable--hide');
  }

  const productForm = document.querySelector(
      `#product-form-${this.dataset.section}`
    ),
    currentVariantInput = e.target;

  if (!productForm) return;
  // update window object

  let currentVariantPrice = this.currentVariant?.price / 100;
  let currentVariantHasFreeShipping = false;

  if (window.delivery.variables != undefined) {
    if (window.delivery.variables.free_threshold < currentVariantPrice) {
      currentVariantHasFreeShipping = true;
    }
  }

  if (window.delivery.variables == undefined) {
    if (window.delivery.free_threshold < currentVariantPrice) {
      currentVariantHasFreeShipping = true;
    }
  }

  window.selected_variant_delivery_info = {
    variant_id: this.currentVariant?.id,
    shipping_delay: parseInt(currentVariantInput.dataset.shippingDelay),
    available: this.currentVariant?.available,
    free_shipping: currentVariantHasFreeShipping,
    has_preorder_status: JSON.parse(
      currentVariantInput.dataset.variantHasPreorderStatus
    ),
    instock_date: currentVariantInput.dataset.instockDate,
    price: this.currentVariant?.price / 100,
  };

  getVariantShippingInfo(
    window.selected_variant_delivery_info.available,
    window.selected_variant_delivery_info.has_preorder_status,
    window.selected_variant_delivery_info.instock_date,
    this.currentVariant?.available
      ? 0
      : window.selected_variant_delivery_info.shipping_delay,
    window.delivery.variables?.min ? window.delivery.variables.min : days_min,
    window.delivery.variables?.max ? window.delivery.variables.max : days_max
  );

  updateFreeShippingInfo(
    window.selected_variant_delivery_info.available,
    currentVariantHasFreeShipping
  );
}

function getVariantShippingInfo(
  available,
  hasPreorderStatus,
  inStockDate,
  shippingDelay,
  min,
  max
) {
  if (!available) {
    return;
  }
  if (hasPreorderStatus == true && inStockDate != '') {
    let inStockDateInMs = new Date(inStockDate).getTime();
    let nowInMs = new Date().getTime();
    if (nowInMs < inStockDateInMs) {
      let datesRange = getDatesRange(inStockDateInMs);
      let deliveryInfoObj = checkWorkingDates(
        datesRange,
        shippingDelay,
        shippingDelay,
        shippingDelay + min,
        shippingDelay + max
      );

      let futureStartDeliveryDate = new Date(deliveryInfoObj.startDeliveryDate);

      let futureEndDeliveryDate = new Date(deliveryInfoObj.endDeliveryDate);
      futureStartDeliveryDate = getDateMonth(futureStartDeliveryDate);

      renderShippingInfo(
        `${window.variantStrings.preorderDelivery} ${convertToLocalDateFormat(
          inStockDate
        )}, ${
          window.delivery.text
        } ${futureStartDeliveryDate}-${convertToLocalDateFormat(
          futureEndDeliveryDate
        )}`,
        '',
        ''
      );
    } else {
      renderShippingInfo(window.variantStrings.preorderDelivery, '', '');
    }
  } else if (hasPreorderStatus == true && inStockDate == '') {
    renderShippingInfo(window.variantStrings.preorderDelivery, '', '');
  } else {
    let datesRange = getDatesRange(
      Date.now() +
        window.selected_variant_delivery_info.shipping_delay * msPerDay
    );

    let deliveryInfoObj = checkWorkingDates(
      datesRange,
      window.selected_variant_delivery_info.shipping_delay,
      window.selected_variant_delivery_info.shipping_delay,
      min + window.selected_variant_delivery_info.shipping_delay,
      max + window.selected_variant_delivery_info.shipping_delay
    );

    renderShippingInfo(
      window.delivery.text,
      getDateMonth(deliveryInfoObj.startDeliveryDate),
      convertToLocalDateFormat(deliveryInfoObj.endDeliveryDate)
    );
  }
}

function renderShippingInfo(text, dateFrom, dateTo) {
  const deliveryInfoModalOpener = document.querySelector(
    '.product-shipping-modal modal-opener'
  );
  let deliveryInfoModalId = deliveryInfoModalOpener.dataset.modal.replace(
    '#',
    ''
  );
  let deliveryInfoModalOpenerTextElm =
    deliveryInfoModalOpener.querySelector('.delivery-info');
  const deliveryInfoModal = document.getElementById(`${deliveryInfoModalId}`);
  let deliveryInfoModalTextElm =
    deliveryInfoModal.querySelector('.delivery-info');
  deliveryInfoModalOpenerTextElm.innerHTML = `${text}`;
  deliveryInfoModalTextElm.innerHTML = `${text}`;
  if (dateFrom != '') {
    deliveryInfoModalOpenerTextElm.innerHTML += `&nbsp;<span>${dateFrom}-${dateTo}</span>`;
    deliveryInfoModalTextElm.innerHTML += `&nbsp;<span>${dateFrom}-${dateTo}</span>`;
  }
}

function convertToLocalDateFormat(date) {
  if (date != undefined || date != '') {
    let data = new Date(date);
    if (Shopify.locale != 'en') {
      let formattedDate = data.toLocaleDateString('de-DE');
      return formattedDate;
    } else {
      let data = new Date(date);
      let dataMonth = data.toLocaleString('default', { month: 'short' });
      let dataDate = data.getDate();
      let dataYear = data.getFullYear();
      let formattedDate = `${dataDate} ${dataMonth} ${dataYear}`;
      return formattedDate;
    }
  }
}

function updateFreeShippingInfo(available, freeShipping) {
  const deliveryInfoModalOpener = document.querySelector(
    '.product-shipping-modal modal-opener'
  );
  let deliveryInfoModalId = deliveryInfoModalOpener.dataset.modal.replace(
    '#',
    ''
  );
  const deliveryInfoModal = document.getElementById(`${deliveryInfoModalId}`);
  let freeDeliveryInfoModalTextElm = deliveryInfoModal.querySelector(
    '.free-delivery-info'
  );

  if (freeDeliveryInfoModalTextElm == undefined) {
    return;
  }

  if (available == false) {
    freeDeliveryInfoModalTextElm.innerHTML = `${window.variantStrings.unavailable}`;
  } else {
    if (window.delivery.variables != undefined) {
      updateIntlFreeShippingInfo();
    } else {
      updateDomesticFreeShippingInfo();
    }
  }

  function updateIntlFreeShippingInfo() {
    if (window.delivery.variables.free_threshold == undefined) {
      freeDeliveryInfoModalTextElm.innerHTML = `${window.delivery.variables.shipping_calculated_at_checkout}`;
    }

    if (window.delivery.variables.free_threshold != undefined) {
      if (
        window.delivery.variables.free_threshold <
        window.selected_variant_delivery_info.price
      ) {
        freeDeliveryInfoModalTextElm.innerHTML = `${window.delivery.free_delivery_success}`;
      } else {
        freeDeliveryInfoModalTextElm.innerHTML = `${window.delivery.variables.free_delivery_info} ${window.delivery.variables.free_threshold_money}`;
      }
    }
  }

  function updateDomesticFreeShippingInfo() {
    if (freeShipping == true) {
      freeDeliveryInfoModalTextElm.innerHTML = `${window.delivery.free_delivery_success}`;
    }

    if (freeShipping == false) {
      freeDeliveryInfoModalTextElm.innerHTML = `${window.delivery.free_delivery_info}`;
    }
  }
}

async function getIntlShippingData() {
  let allData = await fetchIntlData();
  let countryHandle = allData.detected_values.country.handle;
  updateFlag(countryHandle);
  elmCountriesSelect.value = elmCountriesList.querySelector(
    `option[data-country-code="${countryHandle}"]`
  ).value;
  getCountryShippingData(countryHandle);
}

function updateFlag(countryHandle) {
  if (elmCountryFlagWrapper == undefined) {
    return;
  }
  let elmCountryFlag = document.createElement('img');
  elmCountryFlag.src = window.shippingCountries?.flags[countryHandle];
  elmCountryFlagWrapper.innerHTML = '';
  elmCountryFlagWrapper.appendChild(elmCountryFlag);
}

elmCountriesList?.addEventListener('click', (e) => {
  let selectedCountryCode = e.target.dataset.countryCode;
  (async function asyncGetCountryShippingData() {
    await getCountryShippingData(selectedCountryCode);
    updateFlag(selectedCountryCode);
    getDeliveryRange(
      window.delivery.variables.min,
      window.delivery.variables.max
    );
  })();
});

function getCountryShippingData(countryHandle) {
  const currency_symbols = {
    EUR: '€',
    USD: '$',
  };
  let storeCurrencySymbol = currency_symbols[Shopify.currency.active];

  let arrShippingZones = window.shippingSettings.shipping_zones;
  let arrFilteredZones,
    selectedZone,
    zoneFreeShippingProfile,
    minOrderSubtotal,
    minOrderSubtotalPrice,
    intlShippingData;
  let elmCurrentCountryOption = elmCountriesSelect?.querySelector(
    `option[value='${countryHandle}']`
  );
  elmCurrentCountryOption?.setAttribute('selected', true);

  arrFilteredZones = arrShippingZones.map((zone) => {
    return {
      ...zone,
      countries: zone.countries.filter(
        (country) => country.code == countryHandle
      ),
    };
  });

  selectedZone = arrFilteredZones.find((zone) => zone.countries.length > 0);

  zoneFreeShippingProfile = selectedZone.price_based_shipping_rates?.find(
    (rate) => parseFloat(rate.price) == 0
  );

  minOrderSubtotal = zoneFreeShippingProfile?.min_order_subtotal || null;
  minOrderSubtotalPrice = `${storeCurrencySymbol}${minOrderSubtotal}`;

  intlShippingData = {
    zone: selectedZone,
    min_order_subtotal: minOrderSubtotal,
  };

  window.delivery.variables = {
    min: intlShippingData.zone.delivery.days_min,
    max: intlShippingData.zone.delivery.days_max,
    free_delivery_info: 'Free shipping for orders over',
    free_threshold: minOrderSubtotal ? parseInt(minOrderSubtotal) : undefined,
    free_threshold_money: `${storeCurrencySymbol}${parseInt(minOrderSubtotal)}`,
    shipping_calculated_at_checkout: 'Shipping will be calculated at checkout',
  };

  return intlShippingData;
}

async function fetchIntlData() {
  const contextUrl = location.origin + '/browsing_context_suggestions.json';
  try {
    const response = await fetch(contextUrl);
    let data = await response.json();
    return await data;
  } catch (error) {
    console.log(error);
  }
}

// helper functions
function getDatesRange(fromMs) {
  let datesRange = [];
  for (let dd = 1; dd < 50; dd++) {
    let timestamp = fromMs;
    timestamp += msPerDay * dd;
    let dateInRange = convertToDateFormat(timestamp);
    datesRange.push(dateInRange);
  }
  return datesRange;
}

function checkWorkingDates(datesRange, startDelivery, endDelivery, min, max) {
  let startDeliveryDate, endDeliveryDate;
  datesRange.forEach((date) => {
    if (startDelivery < min) {
      let isWorkingDate = isWorkingDay(date, holidays);
      if (isWorkingDate) {
        startDelivery += 1;
        startDeliveryDate = date;
      }
    }
    if (endDelivery < max) {
      let isWorkingDate = isWorkingDay(date, holidays);
      if (isWorkingDate) {
        endDelivery += 1;
        endDeliveryDate = date;
      }
    }
  });

  let workingDatesObj = {
    startDelivery: startDelivery,
    endDelivery: endDelivery,
    startDeliveryDate: startDeliveryDate,
    endDeliveryDate: endDeliveryDate,
  };

  return workingDatesObj;
}

function isWorkingDay(date, holidaysArray) {
  let day = new Date(date).getDay();
  if (day == 0 || day == 6) {
    return false;
  } else if (holidaysArray.includes(date)) {
    return false;
  } else {
    return true;
  }
}

function convertToDateFormat(ms) {
  let newIsoDateString = new Date(ms);
  if (!isNaN(newIsoDateString)) {
    let isoDateString = new Date(ms).toISOString();
    let convertedDate = isoDateString.split('T')[0];
    return convertedDate;
  }
}

function getDateMonth(date) {
  let data = new Date(date);
  let dataDate = data.getDate();
  let dataMonth;
  if (Shopify.locale != 'en') {
    dataMonth = data.getMonth() + 1;
    return `${dataDate}.${dataMonth}.`;
  } else {
    dataMonth = data.toLocaleString('default', { month: 'short' });
    return `${dataDate} ${dataMonth}`;
  }
}

console.log(holidays);
